const proposalTrackingTypes = Object.freeze({
  PropuestaSometida: 1,
  CambioDeEstatus: 2,
  PropuestaAsignada: 3,
  AsignacionManual: 4,
  RemocionDeAsignacion: 5,
  AnulacionDeEvaluacion: 6,
  ConflictoDeInteres: 7,
  PropuestaEvaluada: 8,
  PropuestaRecomendada: 9,
  PropuestaNoRecomendada: 10,
  DocumentoDeEnmiendaSometido: 11,
  CargadosLosDocumentosDeContrato: 12,
  DocumentoAprobado: 13,
  DenegacionDeDocumento: 14,
  AprobacionOGP: 15,
  ContratoRegistradoOC: 16,
});

export default proposalTrackingTypes;
